// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculatorComp":"_12OrpR","results":"_2cF5pe","infoBtn":"_3fNW9f","help":"_1jvInu","numeric":"_1qeIua"};